module.exports = __webpack_public_path__ + "img/pure white holy night.4dc065d3.png";